import { useEffect, useRef, useId, useMemo } from 'react';

import { useScrollNavigationContext } from './context.ts';

interface UseScrollNavigationOptions {
  id?: string;
  error?: boolean;
  dataTestId?: string;
}

export const useScrollNavigation = (title: string, order: number, options?: UseScrollNavigationOptions) => {
  const { registerSection, unregisterSection } = useScrollNavigationContext();
  const scrollToRef = useRef<HTMLDivElement>(null);
  const generatedId = useId();
  const { id: providedId, error, dataTestId } = options || {};

  const id = providedId || generatedId;

  useEffect(() => {
    if (scrollToRef.current) {
      registerSection({
        id,
        title,
        ref: scrollToRef,
        order,
        error,
        dataTestId,
      });
    }
  }, [id, title, order, error, dataTestId, registerSection]);

  useEffect(() => {
    return () => {
      unregisterSection(id);
    };
  }, [id, unregisterSection]);

  return useMemo(() => ({ scrollToRef, id }), [id]);
};
